import axios from "axios";

export default axios.create({
  baseURL: `${window.AD_API_URL}`,
  withCredentials: true
});
